import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { CardActivationStackRoutes, CardActivationStackScreenProps } from './type';
import { CardActivationWebZeroScreen } from './CardActivationWebZero.screen';
import { CardActivationNativeZeroScreen } from './CardActivationNativeZero.screen';
import { CardStatus } from '../../enum';

export interface CardActivationProps {}
export const CardActivationConfirm: React.FC<CardActivationStackScreenProps<CardActivationStackRoutes.Confirm>> = ({
  navigation,
  route
}) => {
  const { onLayout, account, tab, record, func, actionResponse, actionError, onData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});

  if (layout.isMobile) {
    return (
      <CardActivationNativeZeroScreen
        onClose={onGoBack}
        account={account}
        tab={tab}
        record={record}
        func={func}
        actionResponse={actionResponse}
        actionError={actionError}
        onData={onData}
        refresh={refresh}
      />
    );
  }

  return (
    <CardActivationWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      account={account}
      tab={tab}
      record={record}
      func={func}
      actionResponse={actionResponse}
      actionError={actionError}
      onData={onData}
      refresh={refresh}
    />
  );
};
